export const getFullName = (data) => {
  const { first_name, last_name, other_names } = data || {}
  return `${first_name || ''} ${last_name || other_names || ''}`.trim()
}

